import { render, staticRenderFns } from "./TheSearchClient.vue?vue&type=template&id=39b3548a&scoped=true"
import script from "./TheSearchClient.vue?vue&type=script&lang=js"
export * from "./TheSearchClient.vue?vue&type=script&lang=js"
import style0 from "./TheSearchClient.vue?vue&type=style&index=0&id=39b3548a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b3548a",
  null
  
)

export default component.exports